"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "DisabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "EnabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleFailure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleSuccess",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "disableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "enableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModule",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModuleReturnData",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "start",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "pageSize",
                type: "uint256",
            },
        ],
        name: "getModulesPaginated",
        outputs: [
            {
                internalType: "address[]",
                name: "array",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "next",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "isModuleEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ModuleManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ModuleManager__factory = ModuleManager__factory;
//# sourceMappingURL=ModuleManager__factory.js.map